<template>
  <div>
    <ol class="breadcrumb float-xl-end">
      <li class="breadcrumb-item">
        <router-link to="/base-data/boxes"
          >Csoport lakat szekrények</router-link
        >
      </li>
      <li class="breadcrumb-item active">{{ box.name }}</li>
    </ol>
    <h1 class="page-header">Szekrény szerkesztése</h1>
    <Loading v-if="box === false" title="Szekrény betöltése"></Loading>
    <NoRecords
      v-if="box.notfound"
      main_icon="fas fa-user-lock"
      value="false"
      title="Nem található a szekrény"
      subtitle="Menjen vissza a csoport lakat szekrényekhez!"
    ></NoRecords>
    <div class="row" v-if="box !== false && !box.notfound">
      <div class="col-md-6">
        <panel title="Adatok">
          <form @submit.prevent="updateBox()">
            <div class="form-group">
              <label class="form-label" for="number">Szám</label>
              <input
                type="number"
                v-model="box.number"
                required
                class="form-control"
              />
              <div class="bg-danger" v-if="errors.number">
                {{ error.number[0] }}
              </div>
            </div>
            <div class="form-group">
              <label class="form-label" for="name">Megnevezés</label>
              <input
                type="text"
                v-model="box.name"
                required
                class="form-control"
              />
              <div class="bg-danger" v-if="errors.name">
                {{ error.name[0] }}
              </div>
            </div>
            <div class="form-group mt-2">
              <label class="form-label">Munkaterület:</label>
              <div class="input-group">
                <b-dropdown variant="primary">
                  <template slot="button-content">
                    <i class="py-0 fa fa-caret-down"></i>
                  </template>
                  <LocationDropdownRow
                    v-for="(location, id) in locations"
                    :key="id"
                    :location="location"
                    @location-selected="selectLocation"
                  ></LocationDropdownRow>
                </b-dropdown>
                <input
                  type="text"
                  v-model="box.location_name"
                  placeholder="Válassz"
                  class="form-control"
                  :class="{ 'is-invalid': errors.location_id }"
                  disabled
                />
              </div>
              <div v-if="errors.location_id" class="invalid-feedback d-block">
                {{ errors.location_id[0] }}
              </div>
            </div>
            <div class="text-end mt-2">
              <button class="btn btn-primary">
                <i class="fa fa-save"></i> Mentés
              </button>
            </div>
          </form>
        </panel>
      </div>
      <div class="col-md-6">
        <panel title="Lakatok">
          <Loading
            v-if="locks === false || positions == false"
            title="Lakatok betöltése"
          ></Loading>
          <div v-else>
            <form @submit.prevent="addLock()">
              <div class="row">
                <div class="form-group col-4">
                  <label class="form-label">Lakat:</label>
                  <v-select
                    v-if="locks"
                    v-model="lockadd_object.lock_id"
                    :options="
                      locks.filter(
                        (l) =>
                          l.color == 2 &&
                          !box.locks.map((lock) => lock.id).includes(l.id)
                      )
                    "
                    :reduce="(option) => option.id"
                    label="name"
                  >
                    <template #option="{ name }">
                      <i class="fa fa-lock text-warning"></i> {{ name }}
                    </template>
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!lockadd_object.lock_id"
                        v-bind="attributes"
                        v-on="events"
                        :placeholder="!lockadd_object.lock_id ? 'Válassz' : ''"
                      />
                    </template>
                  </v-select>
                </div>
                <div class="form-group col-4">
                  <label class="form-label">Pozíció:</label>
                  <v-select
                    v-if="positions"
                    v-model="lockadd_object.position_id"
                    :options="
                      positions.filter(
                        (p) =>
                          !box.locks
                            .map((l) => l.pivot.position_id)
                            .includes(p.id)
                      )
                    "
                    :reduce="(option) => option.id"
                    label="full_name"
                  >
                    <template #option="{ name, position_id }">
                      {{ position_id }} - {{ name }}
                    </template>
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!lockadd_object.position_id"
                        v-bind="attributes"
                        v-on="events"
                        :placeholder="
                          !lockadd_object.position_id ? 'Válassz' : ''
                        "
                      />
                    </template>
                  </v-select>
                </div>
                <div class="from-group col-2">
                  <label class="form-label">Szám:</label>
                  <input
                    type="number"
                    class="form-control"
                    required
                    v-model="lockadd_object.number"
                  />
                </div>
                <div class="form-group col-2">
                  <button type="submit" class="btn btn-success mt-4">
                    <i class="fa fa-plus"></i> Hozzáadás
                  </button>
                </div>
              </div>
            </form>
            <div class="table-responsive" v-if="box.locks.length != 0">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th>Lakat</th>
                    <th>Pozíció</th>
                    <th>Szám</th>
                    <th class="text-end">Műveletek</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(lock, id) in box.locks" :key="id">
                    <td><i class="fa fa-lock text-warning fa-2x"></i></td>
                    <td>{{ lock.name }}</td>
                    <td>
                      {{
                        positions[
                          positions
                            .map((p) => p.id)
                            .indexOf(lock.pivot.position_id)
                        ].full_name
                      }}
                    </td>
                    <td>{{ lock.pivot.number }}</td>
                    <td class="text-end">
                      <button
                        class="btn btn-danger"
                        @click="deleteLock(lock.id)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </panel>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import NoRecords from "../../components/NoRecords";
import Box from "../../apis/Box";
import Lock from "../../apis/Lock";
import Confirmation from "../../apis/Confirmation";
import Location from "../../apis/Location";
import LocationDropdownRow from "../../components/LocationDropdownRow";

export default {
  components: {
    Loading,
    NoRecords,
    LocationDropdownRow,
  },
  /* KIHAGYTA*/
  data() {
    return {
      box: false,
      errors: [],
      locks: false,
      lockadd_object: {},
      locations: [],
    };
  },
  computed: {
    locationslinear() {
      return this.$store.state.locationslinear;
    },
    positions() {
      return this.$store.state.positions;
    },
  },
  created() {
    Lock.index().then((response) => {
      this.locks = response.data;
    });
    this.positions.forEach((p) => {
      this.$set(p, "full_name", p.position_id + " - " + p.name);
    });

    Box.show(this.$route.params.id)
      .then((response) => {
        this.$set(this, "box", response.data);
        if (this.box.location_id) {
          if (
            this.locationslinear.map((l) => l.id).indexOf(this.box.location_id)
          ) {
            this.selectLocation(
              this.locationslinear[
                this.locationslinear
                  .map((l) => l.id)
                  .indexOf(this.box.location_id)
              ]
            );
          }
        }
      })
      .catch(() => {
        this.$set(this, "box", { name: "ismeretlen", notfound: true });
      });
    Location.index().then((response) => {
      this.locations = response.data;
    });
  },
  methods: {
    selectLocation(location) {
      this.$set(this.box, "location_id", location.id);
      this.$set(this.box, "location_name", location.name);
    },
    deleteLock(lock_id) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          Box.deleteLock(this.$route.params.id, { lock_id: lock_id })
            .then(() => {
              this.box.locks.splice(
                this.box.locks.map((l) => l.lock_id).indexOf(lock_id),
                1
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    addLock() {
      Box.addLock(this.$route.params.id, this.lockadd_object).then(() => {
        this.lockadd_object.name =
          this.locks[
            this.locks.map((l) => l.id).indexOf(this.lockadd_object.lock_id)
          ].name;
        this.lockadd_object.id = this.lockadd_object.lock_id;
        this.lockadd_object.pivot = {
          position_id: this.lockadd_object.position_id,
          number: this.lockadd_object.number,
        };
        this.box.locks.push(this.lockadd_object);
        this.lockadd_object = {};
      });
    },
    updateBox() {
      Box.update(this.$route.params.id, this.box)
        .then(() => {})
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        });
    },
  },
};
</script>

<style></style>
